import React from 'react';
import { ArrowRight, ExternalLink } from 'lucide-react';

const ShopCollections = () => {
  const handleShopClick = () => {
    window.open('https://shop.brownishh.com', '_blank');
  };

  return (
    <section id="shop" className="py-20 bg-lightBrown">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-richBrown mb-6 tracking-tight">
            Shop Collection
          </h2>
          <p className="text-xl text-warmBrown max-w-2xl mx-auto leading-relaxed">
            Streetwear that speaks your truth. Each piece is a statement of cultural pride.
          </p>
          <div className="w-24 h-1 bg-goldAccent mx-auto mt-6"></div>
        </div>

        {/* Featured Collection */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-warmCream rounded-lg overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300">
            <div className="grid lg:grid-cols-2 gap-0">
              {/* Image Section */}
              <div className="relative h-96 lg:h-auto overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_melanin-standard/artifacts/m47lgqno_IMG_0500.jpeg"
                  alt="#Brownishh Collection"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4">
                  <span className="bg-goldAccent text-richBrown px-4 py-2 rounded-full text-sm font-bold">
                    NEW COLLECTION
                  </span>
                </div>
              </div>
              
              {/* Content Section */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <h3 className="text-3xl lg:text-4xl font-black text-richBrown mb-4 tracking-wide">
                  #Brownishh Collection
                </h3>
                <p className="text-warmBrown mb-6 leading-relaxed text-lg">
                  Bold pieces for unstoppable women who own their presence. 
                  Streetwear that celebrates your melanin and cultural pride.
                </p>
                
                <div className="space-y-3 mb-8">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-goldAccent rounded-full"></div>
                    <span className="text-warmBrown">Premium streetwear essentials</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-goldAccent rounded-full"></div>
                    <span className="text-warmBrown">Celebrating brown beauty</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-goldAccent rounded-full"></div>
                    <span className="text-warmBrown">Cultural pride statement pieces</span>
                  </div>
                </div>
                
                <button 
                  onClick={handleShopClick}
                  className="group bg-richBrown hover:bg-goldAccent text-warmCream hover:text-richBrown font-bold py-4 px-8 rounded-none transition-all duration-300 flex items-center gap-2 justify-center tracking-wide text-lg transform hover:scale-105"
                >
                  SHOP COLLECTION
                  <ExternalLink className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-warmBrown to-deepBrown rounded-lg p-8 text-warmCream">
            <h3 className="text-2xl font-bold mb-4">Own Your Style</h3>
            <p className="text-warmCream/90 mb-6 max-w-2xl mx-auto">
              Join thousands of confident women who choose #Brownishh to express their cultural pride through fashion.
            </p>
            <button 
              onClick={handleShopClick}
              className="bg-goldAccent hover:bg-goldAccent/90 text-richBrown font-bold py-3 px-6 rounded-none transition-all duration-300 transform hover:scale-105"
            >
              EXPLORE ALL PIECES
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopCollections;